export default __webpack_public_path__ + "static/media/MintTowerBuilding.91e0e144.svg";